<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
	<mat-error class="top-right-absolute-error-message">{{ 'masterdata.palletising.pallets.dialog.httperror' | translate }}</mat-error>
	}
	<h1 mat-dialog-title class="notification-title">{{ headingKey | translate }}</h1>

	<mat-dialog-content class="mat-dialog-content">
		<mat-form-field appearance="outline" class="dialog">
			@if (controls['name'].invalid && controls['name'].touched) {
			<mat-error>{{ 'masterdata.palletising.pallets.dialog.name.errors.empty' | translate }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'masterdata.palletising.pallets.name' | translate }}</mat-label>
			<input maxlength="50" matInput formControlName="name" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'masterdata.palletising.pallets.description' | translate }}</mat-label>
			<input maxlength="100" matInput formControlName="description" />
		</mat-form-field>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				@if (controls['length'].invalid && controls['length'].touched) {
				<mat-error>{{ 'masterdata.palletising.pallets.dialog.length.error' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.palletising.pallets.dialog.length.label' | translate }}</mat-label>
				<input OnlyNumbers matInput formControlName="length" />
			</mat-form-field>

			<mat-form-field appearance="outline" class="dialog">
				@if (controls['width'].invalid && controls['width'].touched) {
				<mat-error>{{ 'masterdata.palletising.pallets.dialog.width.error' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.palletising.pallets.dialog.width.label' | translate }}</mat-label>
				<input OnlyNumbers matInput formControlName="width" />
			</mat-form-field>

			<mat-form-field appearance="outline" class="dialog">
				@if (controls['height'].invalid && controls['height'].touched) {
				<mat-error>{{ 'masterdata.palletising.pallets.dialog.height.error' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.palletising.pallets.dialog.height.label' | translate }}</mat-label>
				<input OnlyNumbers matInput formControlName="height" />
			</mat-form-field>
		</div>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				@if (controls['weight'].invalid && controls['weight'].touched) {
				<mat-error>{{ 'masterdata.palletising.pallets.dialog.weight.error' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.palletising.pallets.dialog.weight.label' | translate }}</mat-label>
				<input OnlyNumbers matInput formControlName="weight" />
			</mat-form-field>

			<mat-form-field appearance="outline" class="dialog">
				@if (controls['maxHeight'].invalid && controls['maxHeight'].touched) {
				<mat-error>{{ 'masterdata.palletising.pallets.dialog.maxHeight.error' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.palletising.pallets.dialog.maxHeight.label' | translate }}</mat-label>
				<input OnlyNumbers matInput formControlName="maxHeight" />
			</mat-form-field>

			<mat-form-field appearance="outline" class="dialog">
				@if (controls['maxWeight'].invalid && controls['maxWeight'].touched) {
				<mat-error>{{ 'masterdata.palletising.pallets.dialog.maxWeight.error' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.palletising.pallets.dialog.maxWeight.label' | translate }}</mat-label>
				<input OnlyNumbers matInput formControlName="maxWeight" />
			</mat-form-field>
		</div>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				@if (controls['oversize'].invalid && controls['oversize'].touched) {
				<mat-error>{{ 'masterdata.palletising.pallets.dialog.oversize.error' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.palletising.pallets.dialog.oversize.label' | translate }}</mat-label>
				<input OnlyNumbers matInput formControlName="oversize" />
			</mat-form-field>

			<mat-form-field appearance="outline" class="dialog">
				@if (controls['spaceBetween'].invalid && controls['spaceBetween'].touched) {
				<mat-error>{{ 'masterdata.palletising.pallets.dialog.spaceBetween.error' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.palletising.pallets.dialog.spaceBetween.label' | translate }}</mat-label>
				<input OnlyNumbers matInput formControlName="spaceBetween" />
			</mat-form-field>

			<mat-form-field appearance="outline" class="dialog">
				@if (controls['maxLayers'].invalid && controls['maxLayers'].touched) {
				<mat-error>{{ 'masterdata.palletising.pallets.dialog.maxLayers.error' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.palletising.pallets.dialog.maxLayers.label' | translate }}</mat-label>
				<input OnlyNumbers matInput formControlName="maxLayers" />
			</mat-form-field>
		</div>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.palletising.pallets.dialog.dimension' | translate }}</mat-label>
				<mat-select formControlName="dimension">
					<mat-option [value]="null">{{ 'masterdata.cutting.dialog.none' | translate }}</mat-option>
					@for (dimension of dimensions; track dimension) {
					<mat-option [value]="dimension">{{ dimension.name }}</mat-option>
					}
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.palletising.pallets.dialog.type' | translate }}</mat-label>
				<mat-select formControlName="type">
					<mat-option [value]="null">{{ 'masterdata.cutting.dialog.none' | translate }}</mat-option>
					@for (type of types; track type) {
					<mat-option [value]="type">{{ type.name }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</div>
		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'masterdata.palletising.pallets.zipCodeRule' | translate }}</mat-label>
			<mat-select formControlName="zipCodeRule">
				<mat-option [value]="null">{{ 'masterdata.cutting.dialog.none' | translate }}</mat-option>
				@for (rule of rules; track rule) {
				<mat-option [value]="rule">{{ rule }}</mat-option>
				}
			</mat-select>
		</mat-form-field>

		<mat-label class="mat-body-1">{{ 'masterdata.palletising.pallets.dialog.active.label' | translate }}</mat-label>
		<mat-checkbox formControlName="active" />
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">{{ 'masterdata.palletising.pallets.dialog.cancel' | translate }}</button>
		<button mat-flat-button color="primary" type="submit" [disabled]="form.invalid" [ngClass]="{ 'disabled-button': form.invalid }">{{ 'masterdata.palletising.pallets.dialog.ok' | translate }}</button>
	</mat-dialog-actions>
</form>
